module.exports = __webpack_public_path__ + "files/0ae7711a6485fbee3537d34b92e43416.png";